import React, { useEffect, useState } from 'react'
import './ClientManual.css'
import Flipbook from './Flipbook';
import PortalHeader from '../clientNavbar/PortalHeader'

// Icons
import { FaArrowUpRightFromSquare } from "react-icons/fa6";


// Document Interface
interface myDocument {
  DOCUMENT_ID: number;
  DOCUMENT_NAME: string;
  DOCUMENT_DESCRIPTION: string;
  DOCUMENT_TYPE: string;
  FILE_OR_URL: string;
  DOCUMENT_FILE: string | undefined;
  DOCUMENT_URL: string | undefined;
}

const ClientManual = () => {

  // Preprocess galleryData once into a Map
  const [documentsDB, setDocumentsDB] = useState<myDocument[]>([]);

  // useEffect(() => {
  //   window.scrollTo(0, 0); // Scroll to the top when the component mounts
  // }, []);

  const fetchDetectorDocuments = async () => {
    try {
      const response = await fetch('/api/detectordashdocs', {
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
        },
        credentials: 'same-origin',
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data: myDocument[] = await response.json();
      setDocumentsDB(data); // Assign the fetched gallery data to state
      // console.log(data)

    } catch (err) {
      // Type assertion to 'Error' to access the message property
      if (err instanceof Error) {
        console.error(err.message); // Handle error
      } else {
        console.error('An unknown error occurred'); // Fallback for unknown errors
      }
    }
  };

  useEffect(() => {
    fetchDetectorDocuments();
  }, []); // Empty dependency array to run once on mount

  return (
    <div className='client-manual-wrapper'>
      <PortalHeader />

      {documentsDB
        .filter(doc => doc.DOCUMENT_TYPE === 'MANUAL' && !doc.DOCUMENT_NAME.includes("Dashboard")) // or whichever filter you want
        .map((doc, index) => (
          <div key={doc.DOCUMENT_ID} className='client-manual-doc'>
            <h1>{doc.DOCUMENT_NAME}</h1>
            <p>
              {doc.DOCUMENT_DESCRIPTION}
              {doc.DOCUMENT_FILE && (
                <div className='manual-pdf-wrapper'>
                  <FaArrowUpRightFromSquare
                    className='manual-pdf-icon'
                    onClick={() => window.open(doc.DOCUMENT_FILE, '_blank')}
                  />
                </div>
              )}
            </p>


            {/* <iframe
              src={doc.DOCUMENT_FILE}
              width="100%"
              height="600px"
              title={doc.DOCUMENT_NAME}
            /> */}

            <div className='manual-flipbook'>
              {doc.DOCUMENT_FILE ? (
                <Flipbook pdfUrl={doc.DOCUMENT_FILE} />
              ) : (
                <p>PDF file is missing or unavailable.</p>
              )}
            </div>

          </div>
        ))}


    </div>
  )
}

export default ClientManual